import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';

import type { PageFrameProps } from 'src/components/common/PageFrame';
import PageFrame from 'src/components/common/PageFrame';
import PageNotFound from 'src/components/common/PageNotFound';

import SurveySettingsForm from './SurveySettingsForm/SurveySettingsForm';
import { useSurveyDetailQuery } from './api';

import { styles } from './index.styles';

const SurveySettingsPage: FC<PageFrameProps> = ({ ...props }) => {
  const { t } = useTranslation('survey');
  const { data: survey, isFetching: isLoading } = useSurveyDetailQuery();

  return (
    <PageFrame {...props}>
      {isLoading && <CircularProgress />}
      {!survey && !isLoading && <PageNotFound />}
      <Box
        sx={[{ display: isLoading || !survey ? 'none' : 'block' }, styles.root]}
      >
        <Typography variant="h5">{t('settings.headline')}</Typography>
        <SurveySettingsForm />
      </Box>
    </PageFrame>
  );
};

export default SurveySettingsPage;
